import { render, staticRenderFns } from "./sngPopup.vue?vue&type=template&id=0acfcf97&scoped=true&"
import script from "./sngPopup.vue?vue&type=script&lang=js&"
export * from "./sngPopup.vue?vue&type=script&lang=js&"
import style0 from "./sngPopup.vue?vue&type=style&index=0&id=0acfcf97&lang=scss&scoped=true&"
import style1 from "./sngPopup.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acfcf97",
  null
  
)

export default component.exports